module.exports = __webpack_public_path__ + "static/img/8.b5c7b457.jpg";